import { render, staticRenderFns } from "./SharedArticlesPage.vue?vue&type=template&id=f95ff60e&scoped=true&"
import script from "./SharedArticlesPage.vue?vue&type=script&lang=js&"
export * from "./SharedArticlesPage.vue?vue&type=script&lang=js&"
import style0 from "./SharedArticlesPage.vue?vue&type=style&index=0&id=f95ff60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95ff60e",
  null
  
)

export default component.exports